import { useMemo } from 'react'

import { useUnit } from 'effector-react'
import type { DateRange } from 'react-day-picker'
import { useQuery } from 'react-query'

import { $creatorId } from '@/models/creators.ts'
import { getAutoFollowCaption } from '@/modules/automations/service/automations-service.ts'

export interface UseAutoFollowCaptionProps {
  dateRange: DateRange
}

export const useAutoFollowCaption = ({
  dateRange,
}: UseAutoFollowCaptionProps) => {
  const creatorId = useUnit($creatorId)
  const { data, isFetching, isIdle, refetch } = useQuery(
    ['auto-follow-caption', dateRange, creatorId],
    () => getAutoFollowCaption({ dateRange, creatorId: creatorId! }),
    {
      keepPreviousData: true,
      enabled: !!creatorId,
    },
  )

  return useMemo(() => {
    return {
      data,
      isFetching: isFetching || isIdle,
      refetch,
    }
  }, [data, isFetching, isIdle, refetch])
}
